import styled from 'styled-components';
import StepBar, { StepBarProps } from '@components/StepBar/StepBar';
import { BLACK, PALE_BLUE } from '@styles/colors';
import CircleBackground from '@assets/images/CircleBackground.png';
import { safeAreaInset } from '@lib/telegram';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
  padding: 0 0px;
`;

export const Body = styled.div`
  height: 100%;
  overflow-y: auto;
  padding: 0 12px;
  flex-direction: column;
  background-color: ${PALE_BLUE};
  background-image: url(${CircleBackground});
  background-size: contain;
  background-position: right;
  background-repeat: no-repeat;
`

export const StyledStepBar = styled(StepBar)<StepBarProps>`
  margin: 16px 0px 8px 0px;
`;

export const Description = styled.p`
  font-size: 13px;
  line-height: 16px;
  color: #333;
  text-align: center;
  margin-bottom: 24px;
  max-width: 70%;
  margin: 16px auto;
`;

export const Title = styled.p`
  color: ${BLACK};
  font-size: 13px;
  font-weight: 450;
  margin-bottom: 16px;
`

export const ButtonContainer = styled.div`
  margin-top: auto;
  padding-bottom: 24px;
  position: absolute;
  bottom: 0;
  left: 0;
  padding: 16px 12px 24px 12px;
  width: 100%;
  padding-bottom: ${safeAreaInset().bottom || 24}px;
  background-color: ${PALE_BLUE};
`;

export const Separator = styled.div`
  height: 1px;
  background-color: #E5E7EB;
  margin: 24px 0;
  width: 100%;
`;

export const Spacer = styled.div`
  width: 100%;
  height: 30%;
`;
